import { circOut } from 'svelte/easing';
import { get } from 'svelte/store';
import { reducedMotion } from '../stores/reduced-motion.js';
function bounds(value, [outMin, outMax], [inMin, inMax] = [0, 1]) {
    return ((value - inMin) * (outMax - outMin)) / (inMax - inMin) + outMin;
}
export function appear(node, params = {}) {
    const style = getComputedStyle(node);
    const height = node.offsetHeight;
    const originalOpacity = Number(style.opacity);
    const originalTransform = style.transform === 'none' ? '' : style.transform;
    let transformOrigin = 'center';
    let transformY = height * 2;
    if (params.position) {
        transformOrigin = params.position.startsWith('bottom') ? 'bottom' : 'top';
        transformY = params.position.startsWith('bottom') ? height : -height;
    }
    return {
        duration: params.duration ?? 300,
        easing: circOut,
        css: (t) => {
            if (get(reducedMotion)) {
                return `opacity: ${t * originalOpacity}`;
            }
            const y = bounds(t, [transformY, 0]);
            const scale = bounds(t, [0.6, 1]);
            return `
        will-change: transform;
        transform-origin: ${transformOrigin};
        transform: ${originalTransform} translate3d(0,${y}px,0) scale(${scale});
        opacity: ${t};
      `;
        }
    };
}
